// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__LUwD0","question":"Question_question__3_3ae","description":"Question_description__1w-DP"};